import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import { GlobalFunction } from "../../routes/services/globalFuntion";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { FormControl, FormGroup } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { TestConfig } from "./interfaces/interfaces";
import { DeviceFramesDynamicService } from "./services/device.service";
import { Subscription } from "rxjs";
import { StorageService } from "../../routes/services/storage.service";
import { TranslatorService } from "../../core/translator/translator.service";

@Component({
  selector: "app-frames-device-dynamic",
  templateUrl: "./frames_device_dynamic.html",
  styleUrls: ["./frames_device_dynamic.scss"]
})
export class FramesDeviceDynamicComponent implements OnInit {
  @Output("closed") closed = new EventEmitter();
  @ViewChild("frameModal") public modal;
  @Input() type: "waterwise" | "feeder" = "feeder";
  deviceMenu: TestConfig[] = [];

  @Input() devices: any = [
    /*   {
      id: 22,
      mac: "0000000000000001",
      last_login: "2024-11-22T10:54:20.544039-07:00",
      name: "W0001",
      device_type: 0,
      created_at: "2024-11-22T10:54:20.529833-07:00",
      updated_at: "2024-11-22T10:54:20.531393-07:00",
      lat: 25.313213324835505,
      lng: -108.38705351651451,
      battery: 13.62,
      panel: 18.73,
      signal_strength: 0,
      power: true,
      fuzzy_logic: false,
      nas_version: "_",
      device_check: true,
      device_status: {
        battery: {
          status:'',
          received: ''
        },
      },
    }, */
  ];

  temporal_devices: any = [];

  /* para saber cuando esta inicializado el componente y poder validar */
  initialValue = false;
  modalRef: null | any = null;
  close = false;

  filters: FormGroup;
  socketSubsciption: Subscription;

  constructor(
    public globalFunction: GlobalFunction,
    private modalService: NgbModal,
    config: NgbModalConfig,
    public frameDynamicService: DeviceFramesDynamicService,
    public storageService: StorageService,
    public translatorService: TranslatorService
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "xl";
    config.centered = true;
    config.animation = false;

    this.filters = new FormGroup({
      name: new FormControl(""),
      status: new FormControl(""),
      pond: new FormControl("")
    });
  }

  @HostListener("document:click", ["$event"])
  onClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const myDiv: any = document.querySelector(`[id='frame-modal']`);
    const validateClassSwall = () => {
      const views = [
        "swal2-header",
        "swal2-container",
        "swal2-cancel",
        "swal2-popup",
        "swal2-title",
        "swal2-html-container",
        "swal2-icon-content",
        "swal2-icon",
        "swal2-confirm",
        "swal2-actions"
      ];
      const some = views.some((item) => targetElement.classList.contains(item));
      return some;
    };

    if (
      this.initialValue &&
      targetElement.id !== "menu-alert-ponds" &&
      targetElement.id !== "check-feeder" &&
      this.modalRef !== null &&
      !validateClassSwall() &&
      myDiv &&
      !myDiv.contains(targetElement) &&
      !this.close
    ) {
      this.closeModal();
      event.stopPropagation();
    }
  }
  ngAfterViewInit(): void {
    this.openModal();
  }

  ngOnInit(): void {
    let input = ["name", "pond", "status"];
    input.forEach((element) => {
      this.filters.controls[element].valueChanges.pipe(debounceTime(700)).subscribe((search) => {
        this.filterItems();
      });
    });

    if (this.type) {
      this.deviceMenu = this.frameDynamicService.getMenuConfig(this.type).map((item) => item);
      let device_status = {};
      this.deviceMenu.forEach((item) => {
        device_status[item.type_frame] = {
          status: "",
          received: "",
          failReason: ""
        };
      });
      this.devices = this.devices.map((item) => {
        return {
          ...item,
          device_check: true,
          device_status
        };
      });

      this.temporal_devices = this.devices.map((item) => item);
    }

    /* OBTENER POR EL SOCKET*/
    this.socketSubsciption = this.storageService.watchStorage("socket").subscribe((msg: any) => {
      if (this.type === "waterwise") {
        let result = this.globalFunction.setDataWaterwises(this.devices, msg);
        if (result.waterwiseChanged.length > 0) {
          const idxMenu = this.deviceMenu.findIndex((item) => item.type_frame === msg.data.type);
          const waterwise = result.waterwiseChanged.find((water) => water["mac"] === msg.data.mac);

          if (idxMenu >= 0) {
            const idxFeeder = this.devices.findIndex((item) => item.mac === msg.data.mac);
            const idxTemporal = this.temporal_devices.findIndex(
              (item) => item.mac === msg.data.mac
            );

            if (idxFeeder >= 0) {
              this.setStatusDevice({
                indexDevice: idxFeeder,
                data: waterwise,
                name: this.deviceMenu[idxMenu].type_frame,
                status: "done",
                received: this.calculateTime(this.deviceMenu[idxMenu].sent)
              });
            }
          }
        }
      }
    });
  }

  closeModal = async () => {
    this.close = true;

    if (!this.globalFunction.validateSoloAdmin()) {
      let bool = await this.globalFunction.optionSwalAlert(
        this.translatorService.translate("frames-device-dynamic.close-panel-confirm")
      );
      if (bool && this.close) {
        this.modalService.dismissAll();
        this.modalRef = null;
        this.closed.emit(false);
      } else {
        setTimeout(() => {
          this.close = false;
        }, 300);
      }
    } else {
      this.modalService.dismissAll();
      this.modalRef = null;

      this.closed.emit(false);
    }
  };
  calculateTime = (initial) => {
    const finish = moment().format("HH:mm:ss");
    const entryHour = moment(initial ? initial : "", "hh:mm:ss");
    const exitHour = moment(finish, "hh:mm:ss");
    const duration = moment.duration(exitHour.diff(entryHour));
    return `${duration.hours()}:${duration.minutes()}:${duration.seconds()}`;
  };
  setStatusDevice({ indexDevice, data = {}, name, status, received = "", failReason = "" }) {
    this.devices.splice(indexDevice, 1, {
      ...this.devices[indexDevice],
      ...data,
      device_status: {
        ...this.devices[indexDevice].device_status,
        [name]: {
          ...this.devices[indexDevice].device_status[name],
          status,
          received,
          failReason
        }
      }
    });
    this.filterItems();
  }
  validateErrorDevice = (errors, menu, devices) => {
    for (const key in errors) {
      if (Object.prototype.hasOwnProperty.call(errors, key)) {
        const index = devices.findIndex((item) => item.mac === key);
        if (index >= 0) {
          this.setStatusDevice({
            indexDevice: index,
            name: menu,
            status: "error",
            failReason: errors[key]
          });
        }
      }
    }
  };
  clickButtonMenu(menu, idxMenu) {
    const checks = this.devices.filter((item) => item.device_check);
    const hour = moment().format("HH:mm:ss");
    if (menu.type_frame === "ON" || menu.type_frame === "OFF") {
      this.devices.forEach((element, idx) => {
        this.devices[idx].device_status[menu.type_frame] = {
          status: "loading",
          received: "",
          failReason: ""
        };
        this.devices[idx].device_status[menu.type_frame === "ON" ? "OFF" : "ON"] = {
          status: "",
          received: "",
          failReason: ""
        };
      });
    }
    const list_devices = menu.validateDevices([...this.devices]);
    this.deviceMenu[idxMenu].sent = hour;
    list_devices.forEach((device) => {
      const index = this.devices.findIndex((item) => item.name === device.name);
      if (index >= 0) {
        this.setStatusDevice({
          indexDevice: index,
          name: menu.type_frame,
          status: "loading"
        });
      }
    });

    let query = `?id_in=${checks.map((item) => item.id)}`;
    this.deviceMenu[idxMenu].petition(query).then((resp) => {
      if (resp && Object.prototype.hasOwnProperty.call(resp.errors, "errors")) {
        this.validateErrorDevice(resp.errors, menu.type_frame, list_devices);
      }
    });
  }
  individualPetition({ menu, device }) {
    const index = this.devices.findIndex((item) => item.name === device.name);
    if (index >= 0) {
      this.setStatusDevice({
        indexDevice: index,
        name: menu.type_frame,
        status: "loading"
      });
    }
    let query = `?id_in=${device.id}`;
    menu.petition(query).then((resp) => {
      if (resp && Object.prototype.hasOwnProperty.call(resp.errors, "errors")) {
        this.validateErrorDevice(resp.errors, menu.type_frame, [device]);
      }
    });
  }

  openModal = async () => {
    const ref = await this.modalService.open(this.modal);
    await ref.shown.subscribe(() => {
      this.modalRef = ref;
      setTimeout(() => {
        this.initialValue = true;
      }, 100);
    });
  };
  validateAlertColor = (menu, device) => {
    if (menu.validateStatus(menu, this.devices).type === 0) {
      return "d-none";
    }
    if (device.device_status[menu.type_frame].status === "loading") {
      return "color-alert-loading";
    }
    if (device.device_status[menu.type_frame].status === "done") {
      return "color-alert-success";
    }
    if (device.device_status[menu.type_frame].status === "error") {
      return "color-alert-danger";
    }
    return "";
  };

  filterItems = () => {
    const { name, status, pond } = this.filters.value;
    const array = this.devices;

    this.temporal_devices = array.filter((item) => {
      if (!name && !status && !pond) {
        return true;
      }

      // Verifica si el ID coincide exactamente
      if (pond && Number(item.id) !== Number(pond)) {
        return false;
      }

      // Verifica si el nombre contiene la subcadena buscada (coincidencia parcial)
      if (name && !item.type_frame.includes(name)) {
        return false;
      }

      // Verifica si alguno de los estados dentro de device_status coincide con el status buscado
      const deviceStatus = item.device_status;
      if (deviceStatus) {
        for (let key in deviceStatus) {
          if (deviceStatus[key].status === status) {
            return true; // Si encuentra un estado que coincide, retorna true
          }
        }
      }
      // Si no se encontró ningún estado que coincida, retorna false
      return false;
    });
  };
}
